var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('itemCard',{attrs:{"type":_vm.type,"data":_vm.computedData,"action":_vm.action,"actionText":_vm.actionText,"updated_at":_vm.updated_at}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }